import Vue from 'vue';
import {  Prop, Watch } from 'vue-property-decorator';
import { ICalculatedProductPrice, ProductPriceKey, IPrice, ICurrencyKey } from 'Api/CoreApi';
import Component from 'vue-class-component';

import PriceApi from 'Api/PriceApi';
import ABaseComponent from 'Components/Base/ABaseComponent';


@Component({
    template: '#async-price-template'
})
export default class AsyncPriceComponent extends ABaseComponent {
    // Properties
    @Prop()
    productId: string;
    @Prop()
    variantId: string;
    @Prop()
    unitOfMeasure: string;

    price: ICalculatedProductPrice = new ICalculatedProductPrice({ unitPrice: new IPrice });
    error : string = '';

    mounted() {
        this.calculatePrice();
    }

    @Watch('unitOfMeasure')
    public unitOfMeasureChanged() {
        this.calculatePrice();
    }

    private async calculatePrice() {
        let priceApi = PriceApi.getInstance();
        this.setLoading();
        priceApi.get(new ProductPriceKey({
                productId: this.productId,
                variantId: this.variantId,
                unitOfMeasure: this.unitOfMeasure,
                extraInfo: {}
            })).then(price => {
                this.price = price;
                this.setLoaded();
            })
            .catch(e => {
                this.setError("Error");
            });

    }
}

Vue.component('async-price', AsyncPriceComponent);
